export const GROUP_ORDER = ['Today', 'Yesterday', 'This week', 'Earlier'];

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "";
  const rawDate = timestamp?.$date || timestamp?.date || timestamp;
  const parsedDate = new Date(rawDate);
  if (Number.isNaN(parsedDate.getTime())) return "";
  const dateStr = parsedDate.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  const timeStr = parsedDate.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  return `${dateStr}, ${timeStr}`;
};

export const toTimestampMs = (timestamp) => {
  if (!timestamp) return 0;
  const rawDate = timestamp?.$date || timestamp?.date || timestamp;
  const parsed = new Date(rawDate);
  return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

export const formatTime = (ts) => {
  if (!ts) return '';
  return new Date(ts * 1000).toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const getDayGroup = (ts) => {
  if (!ts) return 'Earlier';
  const diff = Math.floor(Date.now() / 1000) - ts;
  if (diff < 86400)  return 'Today';
  if (diff < 172800) return 'Yesterday';
  if (diff < 604800) return 'This week';
  return 'Earlier';
};